import './api'
import isWithoutNav from './isWithoutNav'

// Any IE polyfills etc

if (typeof globalThis === 'undefined' && typeof window != 'undefined') {
  // @ts-ignore
  window.globalThis = window
}
